export const featureSlugToName = {
  "analytics:visao-geral": "Visão Geral",
  "analytics:insights-ia": "Insights IA",
  "analytics:arquiteto": "Arquiteto",
  "analytics:performance-de-midia": "Performance de Mídia",
  "analytics:taxa-de-conversao": "Taxa de Conversão",
  "analytics:aquisicao": "Aquisição",
  "analytics:utm": "UTM",
  "analytics:paginas": "Páginas",
  "analytics:receita": "Receita",
  "analytics:regiao": "Região",
  "analytics:seo": "SEO",
  "analytics:instagram": "Instagram",
  "analytics:historico": "Histórico",
  "analytics:ads": "ADS",
  "analytics:analise-diaria": "Análise Diária",
  "analytics:analise-diaria-por-canal": "Análise diária por canal",
  "analytics:analise-mensal-por-canal": "Análise mensal por canal",
  "analytics:analise-de-ticket-medio": "Análise de Ticket Médio",
  "analytics:analise-de-aquisicao-por-categoria-e-produto":
    "Análise de Aquisição por Categoria e Produto",
  "analytics:benchmark": "Benchmark",
  "analytics:conversion-rate": "Conversion Rate Page",
  "analytics:google-ads-ga4": "Google Ads > GA4",
  "analytics:google-ads-page": "Google Ads Page",
  "analytics:google-analytics-page": "Google Analytics Page",
  "analytics:media-performance": "Media Performance Page",
  "analytics:meta-melhores-resultados": "Meta Melhores Resultados",
  "analytics:meta-ads-ga4": "Meta Ads > GA4",
  "analytics:meta-ads-page": "Meta Ads Page",
  "analytics:produtos": "Produtos",
  "analytics:saude-do-site": "Saúde do Site",
  "analytics:search-console-page": "Search Console Page",
  "analytics:seo-marca": "SEO Marca",
  "analytics:seo-pagina-de-entrada": "SEO Página de Entrada",
  "integrations:instagram-insights": "Instagram Insights",
  "integrations:integracoes": "Integrações",
  "integrations:google-analytics": "Google Analytics",
  "integrations:google-ads": "Google Ads",
  "integrations:search-console": "Search Console",
  "integrations:meta-ads": "Meta Ads",
  "support:email": "Email",
  "support:ticket": "Ticket",
  "support:whatsapp": "Whatsapp",
  "support:telefone": "Telefone",
  "support:canal-prioritario": "Canal Prioritário",
  "automation:alertas": "Alertas",
} as const;

export type FeatureSlug = keyof typeof featureSlugToName;

export const SLUGS = {} as Record<FeatureSlug, FeatureSlug>;
for (const key of Object.keys(featureSlugToName) as FeatureSlug[]) {
  (SLUGS as Record<string, FeatureSlug>)[key] = key;
}
